/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Toast_Enter_RoleInputs */

const en_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a role type`)
};

const de_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib einen Rollentyp ein`)
};

const fr_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre un type de poste`)
};

const es_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese un tipo de puesto`)
};

const it_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un tipo di ruolo`)
};

const nl_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een type rol in`)
};

const pl_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj typ roli`)
};

const fi_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä tehtävätyyppi`)
};

const da_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast en rolletype`)
};

const sv_interview_qbank_toast_enter_role = /** @type {(inputs: Interview_Qbank_Toast_Enter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange en rolltyp`)
};

/**
* | output |
* | --- |
* | "Enter a role type" |
*
* @param {Interview_Qbank_Toast_Enter_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_toast_enter_role = /** @type {((inputs?: Interview_Qbank_Toast_Enter_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Toast_Enter_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_toast_enter_role(inputs)
	if (locale === "fr") return fr_interview_qbank_toast_enter_role(inputs)
	if (locale === "es") return es_interview_qbank_toast_enter_role(inputs)
	if (locale === "it") return it_interview_qbank_toast_enter_role(inputs)
	if (locale === "nl") return nl_interview_qbank_toast_enter_role(inputs)
	if (locale === "pl") return pl_interview_qbank_toast_enter_role(inputs)
	if (locale === "fi") return fi_interview_qbank_toast_enter_role(inputs)
	if (locale === "da") return da_interview_qbank_toast_enter_role(inputs)
	if (locale === "sv") return sv_interview_qbank_toast_enter_role(inputs)
	return en_interview_qbank_toast_enter_role(inputs)
});